mutation DownloadMediaFolder($clientId: ID!, $folderId: ID!) {
    downloadMediaFolder(clientId: $clientId, folderId: $folderId)
}
